<template>
    <div class="security-wrapper">
        <header-security v-if="isJACareerEntrepreApp"/>
        <div class="security">
            <b-container :class="[isJACareerEntrepreApp ? 'security-container' : '']">
                <b-row v-if="isIntuitApp" class="d4d-decoration">
                </b-row>
                <b-row v-if="isJAApp" class="ja-decoration">
                </b-row>
                <b-form @submit.prevent="forgot()" v-if="!isJACareerEntrepreApp">
                    <b-row class="d4d-login">

                        <b-col cols="12" class="mt-1 title">Log In Help</b-col>

                        <b-col cols="12" class="mt-3">
                            <label for="email">Email address</label>
                            <input id="email" type="text" v-model="form.email" value="">
                            <span v-if="emailError" class="form-error">This field is required</span>
                            <ul class="error-content ">
                                <li class="error-text" v-for="error in emailErrors" :key="error">{{ error }}</li>
                            </ul>
                        </b-col>
                        <b-col cols="12" class="mt-4">
                            <b-button block variant="primary" type="submit">Continue</b-button>
                        </b-col>
                        <b-col cols="12" class="mt-2 mb-4">
                            <b-button block variant="light" :to="{ name: 'home' }">Cancel</b-button>
                        </b-col>
                    </b-row>
                </b-form>
                <b-form @submit.prevent="forgot()" v-if="isJACareerEntrepreApp">
                    <b-row class="security-content">

                        <b-col cols="12" class="mt-1 security-title">Log In Help</b-col>

                        <b-col cols="12" class="mt-3 security-section">
                            <label for="email" class="security-section__subtitle">Email address</label>
                            <input class="security-section__input" id="email" type="text" v-model="form.email" value="">
                            <span v-if="emailError" class="text-error">This field is required</span>
                            <ul class="security-section__list">
                                <li class="text-error" v-for="error in emailErrors" :key="error">{{ error }}</li>
                            </ul>
                        </b-col>
                        <b-col cols="12" class="mt-3 security-button">
                            <b-button block variant="primary" type="submit" class="security-button__primary">Continue</b-button>
                        </b-col>
                        <b-col cols="12" class="mb-4 security-button">
                            <b-button variant="outline-primary" block class="button-cancel" :to="{ name: 'home' }">Cancel</b-button>
                        </b-col>
                        <b-col class="security-footer">
                            <span class="security-footer__text">©Junior Achievement USA</span>
                        </b-col>
                    </b-row>
                </b-form>
                <legal-message v-if="!isJACareerEntrepreApp"/>
            </b-container>
        </div>
    </div>
</template>

<script>
    import {UserService} from '../Services';
    import {Spinner} from '../../../core/Utils'
    import LegalMessage from "../Components/LegalMessage"
    import validateForms from '../../../core/Mixins/validate-forms'
    import HeaderSecurity from "../Components/HeaderSecurity"

    export default {
        name: 'ForgotPassword',
        components: {
            LegalMessage,
            HeaderSecurity
         },
        mixins: [validateForms],
        data() {
            return {
                form: {email: ""},
                emailError: false,
                emailErrors: [],
                serviceError: false
            }
        },
        methods: {
            forgot() {
                const email = this.form.email;
                this.emailError = email === "";

                if(email && this.isValidform()){
                    Spinner.start()
                    this.emailErrors = [];
                    this.serviceError = false

                    UserService.changePasswordRequest(email).then(response => {
                        Spinner.stop()
                        this.$router.push({name: 'VerifyEmailPassword' , params: { email }  });
                    }).catch(err => {
                        Spinner.stop()
                        if (err) {
                            if (err.message) {
                                this.serviceError = err.message
                            }
                            if (err.errors && err.errors['Email']) {
                                err.errors['Email'].forEach(error => this.emailErrors.push(error))
                            }
                        }
                    })
                }

            }
        }
    }

</script>

<style scoped lang="stylus">
    @import "../Styles/security_styles.styl"
</style>
